export function getGlobalColor() {
  let color = { color: "", contrast: "", text: "" };
  const userData = localStorage.getItem("user");
  if (userData) {
    const user = JSON.parse(userData);
    if (user.color) {
      color = user.color;
    }
  }
  if (
    !localStorage.getItem("global-color") ||
    localStorage.getItem("global-color") === "undefined"
  )
    color = { color: "" };

  color.color = color.color?.trim() || "";
  color.contrast = color.contrast?.trim() || "";
  color.text = color.text?.trim() || "";
  color.square = color.square?.trim() || "";
  return color;
}

export const createButtonStyles = (color) => {

  const currentGlobalColor = color || getGlobalColor();

  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  let colorOrGradient = currentGlobalColor?.color;

  // If it's a gradient and we're on a mobile device, extract the first hex color
  if (colorOrGradient?.includes("gradient") && isMobile) {
    // Extract the first hex color from the gradient
    // This regex matches hex colors including #RRGGBB, #RGB, #RRGGBBAA, and #RGBA
    const colorMatch = colorOrGradient.match(
      /#([0-9A-Fa-f]{3,4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})\b/
    );
    if (colorMatch && colorMatch[0]) {
      // Use the first hex color found in the gradient
      colorOrGradient = colorMatch[0].trim();
    }
  }

  // Apply gradient or solid color based on the conditions
  const background =
    colorOrGradient?.includes("gradient") && !isMobile
      ? { backgroundImage: colorOrGradient }
      : { background: colorOrGradient || "var(--mantine-primary-color-filled)" };

  return {
    ...background,
    color: currentGlobalColor?.contrast || currentGlobalColor?.text || "var(--mantine-color-white)",
    backgroundAttachment: "fixed",
  };
};

export function setGlobalColor(color) {
  localStorage.setItem("global-color", JSON.stringify(color));
}

